import { defineMessages } from 'react-intl-next';

export const i18n = defineMessages({
	attachedDateLabel: {
		id: 'search-result.attachments.attached-date.label',
		defaultMessage: 'Attached {formattedDate}',
		description: 'Indicates the date the attachment was added',
	},
	expandLabel: {
		id: 'search-result.attachments.expand.label',
		defaultMessage: 'Expand',
		description: 'Icon label to expand the attachment',
	},
	attachmentLabel: {
		id: 'search-result.attachment-label',
		defaultMessage: 'Attachment',
		description: 'Label for attachment',
	},
	pdfLabel: {
		id: 'search-result.attachments.pdf-label',
		defaultMessage: 'PDF',
		description: 'Label for PDF attachment',
	},
	videoLabel: {
		id: 'search-result.attachments.video-label',
		defaultMessage: 'Video',
		description: 'Label for video attachment',
	},
	imageLabel: {
		id: 'search-result.attachments.image-label',
		defaultMessage: 'Image',
		description: 'Label for image attachment',
	},
	audioLabel: {
		id: 'search-result.attachments.audio-label',
		defaultMessage: 'Audio',
		description: 'Label for audio attachment',
	},
});
